import * as types from './types'

const initialState = {
  data: null,
  isFetching: false,
  fields: [],
}

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case types.SET_DATA:
      return { ...state, data: action.payload }
    case types.SET_FIELDS:
      return { ...state, fields: action.payload }
    case types.SET_IS_FETCHING:
      return { ...state, isFetching: action.payload }
    default:
      return state
  }
}
